module.exports = __webpack_public_path__ + "img/icon_promo.04d0a18.webp";